import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import truncate from "lodash/truncate"
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: CENProductDescriptionStyles;
}

type Props = OwnProps;

export interface CENProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    linkStyles?: InjectableCss;
}

export const cenProductDescriptionStyles: CENProductDescriptionStyles = {
    productDetailDescription: {
        css: css`
            display: -webkit-box;
            -webkit-line-clamp: 10;
            -webkit-box-orient: vertical;
            overflow: hidden;
            width: 100%;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            font-family: 'Roboto', sans-serif;
            color: #333333;
            padding: 0px 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                    `,
                    css`
                        padding-left: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    linkStyles: {
        css: css`
                margin-top: 5px;
                display: block;
                &:focus {
                    outline-color: transparent !important;
                }
                > span {
                    color: #2B5197 !important ;
                    font-size: ${TYPOGRAPHY.size.smaller};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    line-height: ${TYPOGRAPHY.lineHeight.smaller};
                }
            `,
    },
};

const NISProductDescription: FC<Props> = ({ product, extendedStyles }) => {
    const [truncated, setTruncate] = useState(true);
    const [styles] = React.useState(() => mergeToNew(cenProductDescriptionStyles, extendedStyles));
    const description = "product" in product ? product.product.content?.htmlContent : "";

    if (!description) {
        return null;
    }
    return (
        <StyledWrapper data-test-selector="productDetailDescription" {...styles.productDetailDescription}>
            

            {!getIsWebCrawler() && truncated
                ? parse(transformContentHtml(truncate(description, { length: 230 })), parserOptions)
                : parse(transformContentHtml(description), parserOptions)}

            {description.length > 230 && !getIsWebCrawler() && (
                <Link href="" onClick={() => setTruncate(!truncated)} {...styles.linkStyles}>
                    {truncated ? "Show More" : "Show Less"}
                </Link>
            )}
        </StyledWrapper>
    );
};

export default NISProductDescription;
